<template>
  <div class="login-box">
    <div class="login-top">
      <div class="login-title">{{ titleText }}</div>
      <!-- <div class="top-right" @click="switchLogin" v-if="titleText!='选择企业账号'">
        <el-tooltip
          popper-class="login-tooltip"
          :content="topRightText"
          placement="left-start"
          effect="light"
          :value="true"
          manual
        >
          <img
            src="../../assets/image/login/login-account.png"
            class="login-account"
            v-if="topRightText=='账号登录'"
          />
          <img src="../../assets/image/login/login-qr.png" class="login-qr" v-else />
        </el-tooltip>
      </div> -->
    </div>
    <div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        label-position="left"
        v-show="titleText == '账号登录'"
      >
        <el-form-item prop="userNameOrEmailAddress">
          <el-input
            v-model="loginForm.userNameOrEmailAddress"
            name="userNameOrEmailAddress"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            :type="passwordType"
            name="password"
            auto-complete="new-password"
            placeholder="请输入密码"
            @keyup.enter.native="handleLogin"
          >
            <img
              slot="suffix"
              src="../../assets/image/login/login-show.png"
              class="login-show"
              v-if="passwordType == 'text'"
              @click="passwordType = 'password'"
            />
            <img
              slot="suffix"
              src="../../assets/image/login/login-secret.png"
              class="login-secret"
              v-else
              @click="passwordType = 'text'"
            />
          </el-input>
        </el-form-item>
      </el-form>
      <el-form
        ref="messageForm"
        :model="messageForm"
        :rules="messageRules"
        class="login-form margin-bottom"
        label-position="left"
        v-show="titleText == '短信登录'"
      >
        <el-form-item prop="userNameOrEmailAddress">
          <el-input
            v-model="messageForm.userNameOrEmailAddress"
            name="userNameOrEmailAddress"
            placeholder="请输入手机号"
            @input="getUserNameOrEmailAddress"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="messageForm.password"
            name="password"
            placeholder="验证码"
            @keyup.enter.native="handleLogin"
          >
            <el-button
              type="text"
              slot="suffix"
              :disabled="isMessageCodeDisabled"
              class="message-code"
              :class="isMessageCodeDisabled ? 'is-disabled' : 'is-normal'"
              @click="sendCode"
              >{{ messageCodeText }}</el-button
            >
          </el-input>
        </el-form-item>
      </el-form>
      <el-form
        class="login-form"
        ref="companyForm"
        :model="companyForm"
        :rules="companyRules"
        label-position="left"
        v-show="titleText == '选择企业账号'"
      >
        <el-form-item prop="company">
          <el-select v-model="companyForm.company" placeholder="请选择公司">
            <el-option
              v-for="item in companys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        class="form-items"
        v-show="
          titleText == '账号登录' ||
          titleText == '短信登录' ||
          titleText == '选择企业账号'
        "
      >
        <!-- <el-checkbox v-model="check" v-show="titleText=='账号登录'">记住密码</el-checkbox> -->
        <el-button
          v-if="titleText == '账号登录'"
          type="primary"
          :loading="isLoginLoading"
          class="login-btn"
          @click.native.prevent="handleLogin('loginForm')"
          >{{ loginBtnText }}</el-button
        >
        <el-button
          v-if="titleText == '短信登录'"
          type="primary"
          :loading="isLoginLoading"
          class="login-btn"
          @click.native.prevent="handleLogin('messageForm')"
          >{{ loginBtnText }}</el-button
        >
        <el-button
          v-if="titleText == '选择企业账号'"
          type="primary"
          :loading="isLoginLoading"
          class="login-btn"
          @click.native.prevent="handleLogin('companyForm')"
          >{{ loginBtnText }}</el-button
        >
        <div class="form-item" v-if="titleText != '选择企业账号'">
          <!-- <span @click="titleText='微信扫码登录'">扫码登录</span> -->
          <!-- <div class="item-line"></div> -->
          <span @click="forgetPass">忘记密码</span>
          <div class="item-line"></div>
          <span @click="messageLogin" v-if="titleText == '账号登录'"
            >短信登录</span
          >
          <span
            @click="accountLogin"
            v-if="titleText == '短信登录' || titleText == '选择企业账号'"
            >账号登录</span
          >
        </div>
        <div class="back-account" @click="titleText = '账号登录'" v-else>
          <svg-icon icon-class="back"></svg-icon>
          <span>切换账号</span>
        </div>
      </div>
    </div>
    <!-- <div class="login-scan" v-if="titleText=='微信扫码登录'">
      <div class="scan-qr">
      </div>
      <p class="scan-tip">打开微信，扫一扫登录</p>
    </div> -->
    <div class="login-bottom" v-if="titleText != '微信扫码登录'">
      <div class="bottom-line"></div>
      <span>知乐时光科技提供技术支持</span>
      <div class="bottom-line"></div>
    </div>
  </div>
</template>

<script>
import { validatePhone, isvalidUsername } from "@/utils/validate";
import { preLoginCheck } from "@/http/api/account";
import store from "@/base/store";
import {
  getExpires,
  setTenantName,
  setPassword,
  getPassword,
  setUserName,
  getUserName,
} from "@/utils/authStore";
export default {
  name: "LoginForm",
  props: {
    redirect: String,
  },
  computed: {
    topRightText() {
      return this.titleText == "微信扫码登录" ? "账号登录" : "扫码登录";
    },
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入手机号"));
      } else {
        if (!validatePhone(value)) {
          callback(new Error("手机号输入不正确"));
        } else {
          callback();
        }
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码输入不正确"));
      } else {
        callback();
      }
      callback();
    };
    const validateCompany = (rule, value, callback) => {
      if (!value && typeof value != "undefined" && value != 0) {
        callback();
      } else if (!value) {
        callback(new Error("请选择公司"));
      }
      callback();
    };
    return {
      loginForm: {
        userNameOrEmailAddress: "",
        password: "",
      },
      messageForm: {
        userNameOrEmailAddress: "",
        password: "",
        type: "Sms",
      },
      companyForm: {
        company: "",
      },
      loginRules: {
        userNameOrEmailAddress: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      messageRules: {
        userNameOrEmailAddress: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      companyRules: {
        company: [
          { required: true, validator: validateCompany, trigger: "change" },
        ],
      },
      isLoginLoading: false,
      showLogin: true,
      check: true,
      titleText: "账号登录",
      passwordType: "password",
      btntxt: "获取验证码",
      messageCodeText: "发送验证码",
      isMessageCodeDisabled: true,
      loginBtnText: "登录",
      tenantId: "",
      companys: [],
      time: 120,
    };
  },
  mounted() {
    if (getUserName() && getPassword()) {
      this.loginForm = {
        userNameOrEmailAddress: getUserName(),
        password: getPassword(),
      };
      this.titleText = "选择企业账号";
      this.preLoginCheck();
    }
  },
  methods: {
    getUserNameOrEmailAddress() {
      if (/^1[34578]\d{9}$/.test(this.messageForm.userNameOrEmailAddress)) {
        this.isMessageCodeDisabled = false;
      } else {
        this.isMessageCodeDisabled = true;
      }
    },
    forgetPass() {
      this.$emit("switch-status");
      this.$router.push({
        path: "/login/forgetPassword",
      });
    },
    switchLogin() {
      this.titleText =
        this.titleText == "微信扫码登录" ? "账号登录" : "微信扫码登录";
      this.$refs.loginForm.resetFields();
      this.loginForm = {
        userNameOrEmailAddress: "",
        password: "",
      };
    },
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "loginForm") {
            this.tenantId = "";
            this.preLoginCheck(this.loginForm);
          } else if (formName == "companyForm") {
            this.tenantId = this.companyForm.company;
            this.companys.map((item) => {
              if (item.id == this.companyForm.company) {
                setTenantName(item.name);
              }
            });
            this.goLogin();
          } else if (formName == "messageForm") {
            this.tenantId = "";
            this.preLoginCheck(this.messageForm);
          }
        }
      });
    },
    // 预登录验证
    preLoginCheck(val) {
      this.loginBtnText = "正在登录";
      this.isLoginLoading = true;
      preLoginCheck(val)
        .then((res) => {
          if (res && res.result.resultCode == "Success") {
            if (res.result.tenants.length == 1 && res.result.tenants[0].id) {
              this.tenantId = res.result.tenants[0].id;
              setTenantName(res.result.tenants[0].name);
              this.goLogin();
            } else if (res.result.tenants.length > 1) {
              this.isLoginLoading = false;
              this.loginBtnText = "登录";
              this.companys = res.result.tenants;
              this.companyForm.company = this.companys[0].id;
              this.titleText = "选择企业账号";
            } else {
              this.tenantId = "";
              this.goLogin();
            }
          } else if (res) {
            this.$message.error({
              message: res.result.description,
              showClose: true,
            });
            this.loginBtnText = "登录";
            this.isLoginLoading = false;
          }
        })
        .catch((err) => {
          this.loginBtnText = "登录";
          this.isLoginLoading = false;
        });
    },
    scanLogin() {},
    accountLogin() {
      this.titleText = "账号登录";
      this.$refs.loginForm.resetFields();
      this.$refs.messageForm.resetFields();
      this.messageForm = {
        userNameOrEmailAddress: "",
        password: "",
        type: "Sms",
      };
      this.loginForm = {
        userNameOrEmailAddress: "",
        password: "",
      };
    },
    messageLogin() {
      this.titleText = "短信登录";
      this.$refs.loginForm.resetFields();
      this.$refs.messageForm.resetFields();
      this.messageForm = {
        userNameOrEmailAddress: "",
        password: "",
        type: "Sms",
      };
      this.messageCodeText = "发送验证码";
      this.isMessageCodeDisabled = true;
      this.loginForm = {
        userNameOrEmailAddress: "",
        password: "",
      };
    },
    sendCode() {
      this.time = 120;
      this.timer();
      let phoneNumber;
      this.isMessageCodeDisabled = true;
      this.$store
        .dispatch("GetCode", this.messageForm.userNameOrEmailAddress)
        .then((res) => {
          //console.log(res);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.messageCodeText = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageCodeText = "获取验证码";
        if (/^1[34578]\d{9}$/.test(this.verifyForm.phoneNumber)) {
          this.isCodedisabled = false;
        } else {
          this.isCodedisabled = true;
        }
      }
    },
    goLogin() {
      let data = {};
      if (this.loginForm.password) {
        data = {
          username: this.loginForm.userNameOrEmailAddress,
          password: this.loginForm.password,
          __tenant: this.tenantId,
        };
      } else if (this.messageForm.password) {
        data = {
          username: this.messageForm.userNameOrEmailAddress,
          password: this.messageForm.password,
          __tenant: this.tenantId,
        };
      }
      this.isLoginLoading = true;
      this.loginBtnText = "正在登录";
      this.$store
        .dispatch("LoginByUsername", data)
        .then((res) => {
          this.$router.push({ path: this.redirect || "/" });
          setPassword(data.password);
          setUserName(data.userNameOrEmailAddress);
          setTimeout(() => {
            const expires =
              Number(getExpires().expires_in) - this.$offsetSeconds;
            setInterval(() => {
              store.dispatch("RefreshToken");
            }, (expires > 0 ? expires : 3600) * 1000);
            //console.log("前往的路径", this.redirect);
          }, 0);
        })
        .catch((err) => {
          this.isLoginLoading = false;
          this.loginBtnText = "登录";
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.login-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  .login-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding-left: 23px;
    width: 100%;
    box-sizing: border-box;

    .login-title {
      font-size: 20px;
      font-weight: 400;
      color: #252b3a;
    }

    .top-right {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      color: #738299;

      img {
        width: 35px;
        height: 33px;
      }
    }
  }

  .login-form {
    padding: 0 23px;

    .login-show {
      position: relative;
      top: 3px;
      cursor: pointer;
      width: 20px;
      height: 12px;
    }

    .login-secret {
      position: relative;
      top: 3.5px;
      cursor: pointer;
      width: 20px;
      height: 15px;
    }

    .message-code {
      font-size: 14px;

      &:focus,
      &:hover {
        background-color: transparent;
        border-color: transparent;
      }
    }

    .is-disabled {
      color: #e0e0e0;
    }

    .is-normal {
      color: $--color-primary;
    }

    .el-select {
      width: 100%;

      ::v-deep .el-input {
        .el-input__inner {
          background-color: transparent;
        }
      }
    }
  }

  .margin-bottom {
    margin-bottom: 19px;
  }

  .form-items {
    display: flex;
    flex-direction: column;
    padding: 0 23px;
    font-size: 12px;
    font-weight: 400;
    color: #252b3a;

    .el-checkbox {
      align-self: flex-end;
    }

    .el-button {
      height: 36px;

      font-size: 14px;
      font-weight: 400;
      color: #fff;
    }

    .form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-top: 20px;
      // padding: 0 25px;
      padding: 0;
      font-size: 12px;
      font-weight: 400;
      color: #252b3a;

      span {
        cursor: pointer;
      }

      .item-line {
        width: 1px;
        height: 12px;
        background: #dfe1e6;
      }
    }

    .back-account {
      height: 12px;
      line-height: 12px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      color: #006eff;

      .svg-icon {
        height: 12px;
        cursor: pointer;
      }

      span {
        cursor: pointer;
      }
    }

    .forgot-item {
      text-align: right;
      margin-top: 10px;

      font-size: 12px;
      font-weight: 400;
      color: #999;

      span {
        color: $--color-primary;
      }
    }
  }

  .login-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    // position: absolute;
    // bottom: 20px;

    font-size: 12px;
    font-weight: 400;
    color: $--color-primary;

    .bottom-line {
      width: 75px;
      height: 1px;
      background: #ddd;
    }
  }

  .login-scan {
    position: absolute;
    top: 87px;
    left: 50%;
    transform: translateX(-50%);

    .scan-qr {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 208px;
      height: 208px;
      border: 1px solid #e5e5e5;

      img {
        width: 158px;
        height: 158px;
      }
    }

    .scan-tip {
      margin-top: 35px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      color: #252b3a;
    }
  }

  @media (max-width: 1919px) {
    .form-items {
      .login-btn {
        margin-top: 30px;
      }
    }
  }

  @media (min-width: 1920px) {
    .form-items {
      .login-btn {
        margin-top: 45px;
      }
    }
  }
}
</style>
